Vue.component('form-chestnut', require('./components/Chestnut.vue').default);